import React from 'react';
import {Container, Grid, GridColumn, GridRow, List, Segment} from 'semantic-ui-react';
import MenuList from "./MenuList";
import AttentionList from "./AttentionList";
import styled from 'styled-components';
import SocialMediaContact from "./SocialMediaContact";
import footerBGImg from "../../resources/footerBG.png";
import fbLogo from '../../resources/fbLogo.png';
import igLogo from '../../resources/igLogo.png';
import twLogo from '../../resources/twLogo.png';
import inLogo from '../../resources/inLogo.png';
import AFPILogo from '../../resources/AFPILogo.png';
import OJKLogo from '../../resources/OJKLogo.png'
import Image from "semantic-ui-react/dist/es/elements/Image/Image";

const siteMapList = [{
    key: 1,
    url: '/',
    label: 'career',
    translate: true
}, {
    key: 2,
    url: '/',
    label: 'blog',
    translate: true
}, {
    key: 3,
    url: '/terms',
    label: 'terms',
    translate: true
}, {
    key: 4,
    url: '/privacyPolicy',
    label: 'privacyPolicy',
    translate: true
}, {
    key: 5,
    url: '/',
    label: 'callUs',
    translate: true
}];

const findUsLink = [{
    key: 1,
    label: 'PT. Microtech DFS Indonesia',
}, {
    key: 2,
    label: 'Thamrin City Office Park Blok AB-07',
}, {
    key: 4,
    label: 'Tanah Abang, Jakarta Pusat, Indonesia 10230',
}, {
    key: 5,
    label: '(+6221) 3199 0646 ; (+6221) 3199 0641',
}];

const attentionList = [{
    key: 1,
    values: 'attention',
    translate: true
}, {
    key: 2,
    values: 'firstDisclaimer',
    translate: true
}, {
    key: 3,
    values: 'secondDisclaimer',
    translate: true
}, {
    key: 4,
    values: 'thirdDisclaimer',
    translate: true
}, {
    key: 5,
    values: 'fourthDisclaimer',
    translate: true
}, {
    key: 6,
    values: 'fifthDisclaimer',
    translate: true
}, {
    key: 7,
    values: 'sixthDisclaimer',
    translate: true
}, {
    key: 8,
    values: 'seventhDisclaimer',
    translate: true
}, {
    key: 9,
    values: 'eightDisclaimer',
    translate: true
}, {
    key: 10,
    values: 'ninthDisclaimer',
    translate: true
}];

const socialMedias = [{
    key: 1,
    media: fbLogo,
    url: '/'
}, {
    key: 2,
    media: igLogo,
    url: '/'
}, {
    key: 3,
    media: twLogo,
    url: '/'
}, {
    key: 4,
    media: inLogo,
    url: '/'
}];

export class Footer extends React.PureComponent {

    constructor(props, context) {
        super(props, context);
    }

    render() {

        const FooterWrapper = styled(Segment)`
            background-color: white !important;
            margin: 0 !important;
            border-radius: 0 !important;
            color: black;
        `;

        const styles = {
          footerBG: {
              backgroundImage: `url(${footerBGImg})`,
              backgroundSize:`cover`,
              backgroundRepeat:`no-repeat`,
              color:`white`,
              padding:`3em`
          }

        };

        const gmapsIframe =`<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.5150456393217!2d106.81445341476909!3d-6.195568395514786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f7b2fa384641%3A0x5b21a902f00bd290!2sBees%20Funding!5e0!3m2!1sid!2sid!4v1575008750507!5m2!1sid!2sid" width="250" height="200" frameborder="0" style="border:0;" allowfullscreen=""></iframe>`;

        const createHTML = (content) => {
            return { __html: content }
        };

        return (
            <FooterWrapper>
                <Container style={{width:'100%'}}>
                    <Grid verticalAlign="middle">
                        <GridRow columns={3} style={styles.footerBG}>
                            <GridColumn computer={4} mobile={8} style={{margin:'0!important'}}>
                                <List>
                                    <MenuList menus={findUsLink}/>
                                </List>
                            </GridColumn>
                            <GridColumn computer={4} mobile={8} style={{margin:'0!important',textAlign:'right'}}>
                                <div dangerouslySetInnerHTML={createHTML(gmapsIframe)}/>
                            </GridColumn>
                            <GridColumn computer={4} mobile={8} style={{margin:'0'}}>
                                <List style={{textAlign:'center'}}>
                                    <MenuList menus={siteMapList}/>
                                </List>
                            </GridColumn>
                            <GridColumn computer={4} mobile={16} style={{margin:'0'}}>
                                <SocialMediaContact socialMediaList={socialMedias}/>
                            </GridColumn>
                        </GridRow>
                        <GridRow style={{padding:'2em 3em 0 3em'}}>
                            <GridColumn computer={5} mobile={8}>
                                <Image src={OJKLogo} size={'medium'}/>
                            </GridColumn>
                            <GridColumn computer={8} mobile={8} style={{paddingTop:'2vw'}}>
                                <Image src={AFPILogo} size={'medium'}/>
                            </GridColumn>
                        </GridRow>
                        <GridRow style={{padding:'1em 3em'}}>
                            <GridColumn columns={16}>
                                <AttentionList contents={attentionList}/>
                            </GridColumn>
                        </GridRow>
                    </Grid>
                </Container>
                <Container text textAlign={'center'} fluid style={{marginTop:'20px',marginBottom:'10px'}}>
                    © 2019 PT Microtech DFS Indonesia. All Rights Reserved.
                </Container>
            </FooterWrapper>
        )
    }
}


export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js